import React, { Dispatch, FC, SetStateAction, useCallback } from 'react';
import { OptionDataPayload, OptionDataValue } from '../../../shared/options';
import { GenericOptionInput } from '../../../shared/orders';
import { RegistrationUpsert } from '../../../shared/registration/model';
import { ProductOptionViewer } from '../../components';

interface RegistrationOptionRendererProps {
  readonly option: GenericOptionInput;
  readonly values: OptionDataPayload;
  readonly isPaidAttendance?: boolean;
  readonly setRegistration: Dispatch<SetStateAction<RegistrationUpsert>>;
}

export const RegistrationOptionRenderer: FC<RegistrationOptionRendererProps> = ({
  option,
  values,
  setRegistration,
  isPaidAttendance,
}) => {
  const onOptionChange = useCallback(
    (id: number, value: OptionDataValue) => {
      setRegistration((old) => ({
        ...old,
        options: {
          ...old.options,
          [id.toString()]: value,
        },
      }));
    },
    [setRegistration],
  );

  let disabled = false;
  if (isPaidAttendance) {
    if (option.type === 'currency') {
      disabled = true;
    }

    if (option.type === 'select' || option.type === 'multi') {
      disabled = !!option.selectValues?.some((t) => t.priceModifier > 0);
    }
  }

  return (
    <ProductOptionViewer
      adminView
      defaultValue={values[option.id] ?? undefined}
      disabled={disabled}
      onChange={onOptionChange}
      option={option}
    />
  );
};
